import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, { Tab } from "material-ui/Tabs";
import Switch from "material-ui/Switch";
import Grid from "material-ui/Grid";
import Radio, { RadioGroup } from "material-ui/Radio";
import List, { ListItem, ListItemText } from "material-ui/List";
import { toast } from "react-toastify";
import Tooltip from "material-ui/Tooltip";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel
} from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

import { validateFormData } from "../../../common/formtool";

import generateNames from "../../../common/namegenerate";

import { CUSTOM_METADATA_STANDARD } from "../../../common/constants";

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#5a5a5a",
    color: "white",
    maxWidth: "auto",
    fontSize: theme.typography.pxToRem(15),
    border: "1px solid #dadde9"
  }
}))(Tooltip);

class NewTests extends React.Component { 
  constructor(props) {
    super(props);
    const { job, isCopperTest, userPreference } = props;
    this.state = {
      open: true,
      errors: {},
      tabs:
        job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)
          ? [
              props.translate("test_details"),
              props.translate("test_standards"),
              props.translate("test_metadata")
            ]
          : [
              props.translate("test_details"),
              props.translate("test_standards")
            ],
      tabPosition: 0,
      testPrefixType: "custom",
      test: {
        jobid: job.id,
        prefix: "",
        startvalue: "01",
        endvalue: "24",
        names: null,
        floor: "",
        telecommunicationspace: "",
        panel: "",
        cablestandard: "",
        cablestandardname: "",
        linkmodel: "",
        linkmodelname: "",
        cabletype: "",
        cabletypename: "",
        cablebrand: "",
        cablebrandname: "",
        cablemodelid: "",
        cablemodelname: "",
        connectorbrandnear: "",
        connectorbrandnearname: "",
        connectorbrandfar: "",
        connectorbrandfarname: "",
        nvp: 68,
        cableshielding: isCopperTest ? "U/UTP" : "S/STP",
        metadata: [
          {
            level: "1",
            value: "",
            field: job.level1,
            default: job.level1 !== "",
            enabled: job.level1 !== ""
          },
          {
            level: "2",
            value: "",
            field: job.level2,
            default: job.level2 !== "",
            enabled: job.level2 !== ""
          },
          {
            level: "3",
            value: "",
            field: job.level3,
            default: job.level3 !== "",
            enabled: job.level3 !== ""
          },
          {
            level: "4",
            value: "",
            field: job.level4,
            default: job.level4 !== "",
            enabled: job.level4 !== ""
          },
          {
            level: "5",
            value: "",
            field: job.level5,
            default: job.level5 !== "",
            enabled: job.level5 !== ""
          },
          {
            level: "6",
            value: "",
            field: job.level6,
            default: job.level6 !== "",
            enabled: job.level6 !== ""
          }
        ]
      },
      cablemodels: [],
      linkmodels: [],
      cabletypes: [],
      isNonGenericCableBrand: false,
      disabledToogleIdentifier: false,
      testIDType: "sequential",
      lantekfiles: null,
      modalRef: React.createRef()
    };
    this.checkForAlreadySelectedSubtests = this.checkForAlreadySelectedSubtests.bind(
      this
    );
    this.handleImport = this.handleImport.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  checkForAlreadySelectedSubtests = (test, isCopper) => {
    let { testCount } = this.state;
    let { job, userPreference } = this.props;
    if (
      (job.metadatalookupid === CUSTOM_METADATA_STANDARD || userPreference.FromTreeview) &&
      userPreference.metadata
    ) {
      let metadata = [...userPreference.metadata];
      let curStateMetaData = [...test.metadata];
      metadata.forEach(e => {
        curStateMetaData.forEach(ce => {
          if (ce.level === e.level) {
            ce.field = e.field;
            ce.value = e.value;
            e.value ? (ce.enabled = true) : (ce.enabled = false);
          }
        });
      });
      test.metadata = curStateMetaData;
      test.allmetadataoptions = true;
      this.setState({
        test: {
          ...test
        }
      });
    }
  };

  handleTabChange = (event, value) => {
    let { tabPosition } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : this.validate();
    if (allowTabChange) {
      this.setState({ tabPosition: value });
    }
  };

  tabNext() {
    let check = this.canTabNext();
    let validate = this.validate();
    if (validate && check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    let check = this.canTabBack();
    if (check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;
    return pos < tabs.filter(n => n).length
      ? { can: true, pos: pos }
      : { can: false, pos: pos };
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : { can: false, pos: pos };
  }

  tabsComplete() {
    const { tabs, tabPosition } = this.state;
    return tabPosition === tabs.filter(n => n).length - 1 ? true : false;
  }

  handleClose = () => {
    this.setState({
      open: false
    });
    this.props.cancel("cancel");
  };

  compare = (a, b) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  };

  onChange = e => {
    const self = this;
    let test = { ...this.state.test };
    let cablemodels = self.state.cablemodels || [];
    let linkmodels = self.state.linkmodels || [];
    let cabletypes = self.state.cabletypes || [];
    let isNonGenericCableBrand = self.state.isNonGenericCableBrand;
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    if (
      e.target.name === "startvalue" &&
      e.target.value.trim() === "" &&
      test.startvalue === ""
    ) {
      return;
    }
    const { job, translate } = this.props;
    let value;
    if (
      job.metadatalookupid !== null &&
      job.metadatalookupid !== CUSTOM_METADATA_STANDARD
    ) {
      if (e.target.name === "floor")
        value =
          e.target.value.length <= 3 ? e.target.value : test[e.target.name];
      if (e.target.name === "telecommunicationspace")
        value =
          e.target.value.length <= 1 ? e.target.value : test[e.target.name];
      if (e.target.name === "panel")
        value =
          e.target.value.length <= 2 ? e.target.value : test[e.target.name];
      if (e.target.name === "startvalue")
        value =
          e.target.value.length <= 4 ? e.target.value : test[e.target.name];
      if (e.target.name === "endvalue")
        value =
          e.target.value.length <= 4 ? e.target.value : test[e.target.name];
    }

    if (e.target.name === "cablestandard") {
      const std = self.props.standards;
      const standard =
        std && std.cablestandards
          ? std.cablestandards.find(x => x.id == e.target.value)
          : null;
      self.setState({
        linkmodels: standard && standard.linkmodels ? standard.linkmodels : []
      });
      if (standard) {
        test.cablestandardname = standard.name;
      }
      if (test[e.target.name] && test[e.target.name] !== e.target.value) {
        test["linkmodel"] = "";
        test["cabletype"] = "";
        test["linkmodelname"] = "";
        test["cabletypename"] = "";
        self.setState({ cabletypes: [] });
      }
    }
    if (e.target.name === "linkmodel") {
      const linkModel = linkmodels
        ? linkmodels.find(x => x.id == e.target.value)
        : null;
      self.setState({
        cabletypes:
          linkModel && linkModel.cabletypes
            ? linkModel.cabletypes.sort(this.compare)
            : []
      });
      test.linkmodelname = linkModel ? linkModel.name : "";
      if (test[e.target.name] && test[e.target.name] !== e.target.value) {
        test["cabletype"] = "";
        test["cabletypename"] = "";
      }
    }

    if (e.target.name === "cabletype") {
      const cabletype = cabletypes
        ? cabletypes.find(x => x.id == e.target.value)
        : null;
      test.cabletypename = cabletype ? cabletype.name : "";
    }

    if (e.target.name === "cablebrand") {
      if (e.target.value) {
        const { standards } = self.props;
        const brand =
          standards && standards.cablebrands
            ? standards.cablebrands.find(x => x.id == e.target.value)
            : null;
        test.cablebrandname = brand ? brand.name : "";
        cablemodels = brand
          ? !this.props.isCopperTest
            ? brand.cablemodels.filter(n => n.coax == true)
            : brand.cablemodels.filter(n => n.coax == false)
          : [];
        if (brand && brand.name.toLowerCase() == "generic") {
          isNonGenericCableBrand = false;
        } else {
          isNonGenericCableBrand = true;
        }
      }
      test.nvp = 68;
      test.cableshielding = "U/UTP";
      test.cablemodelid = "";
      test.cablemodelname = "";
    }

    if (e.target.name === "connectorbrandnear") {
      if (e.target.value) {
        const conns = self.props.standards;
        const connectornear =
          conns && conns.connectorbrands
            ? conns.connectorbrands.find(x => x.id == e.target.value)
            : null;
        test.connectorbrandnearname = connectornear ? connectornear.name : "";
      }
    }

    if (e.target.name === "connectorbrandfar") {
      if (e.target.value) {
        const conns = self.props.standards;
        const connectorfar =
          conns && conns.connectorbrands
            ? conns.connectorbrands.find(x => x.id == e.target.value)
            : null;
        test.connectorbrandfarname = connectorfar ? connectorfar.name : "";
      }
    }

    if (e.target.name === "cablemodelid") {
      if (e.target.value) {
        const cablemodel = cablemodels
          ? cablemodels.find(cablemodel => cablemodel.id == e.target.value)
          : null;
        if (cablemodel) {
          if (
            cablemodel.nvp &&
            (cablemodel.nvp >= 50 && cablemodel.nvp <= 100)
          ) {
            test.nvp = cablemodel.nvp;
          } else {
            test.nvp = 68;
          }
          if (cablemodel.name) {
            test.cablemodelname = cablemodel.name;
          }

          if (cablemodel.screen) {
            test.cableshielding = "S/STP";
          } else {
            test.cableshielding = "U/UTP";
          }
        } else {
          test.nvp = 68;
          test.cableshielding = "U/UTP";
        }
      }
    }

    test[e.target.name] = value ? value : e.target.value;
    if (e.target.name === "startvalue") {
      test["endvalue"] = value ? value : e.target.value;
    }
    if (
      job.metadatalookupid !== null &&
      job.metadatalookupid !== CUSTOM_METADATA_STANDARD
    ) {
      test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
    }

    if (
      this.state.testIDType == "sequential" &&
      test.startvalue &&
      test.endvalue &&
      test.prefix
    ) {
      let names = generateNames(
        test.prefix,
        test.startvalue,
        test.endvalue,
        2000,
        errors
      );
      if (names) {
        test.names = names;
        delete errors.startvalue;
        delete errors.endvalue;
      } else {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.startvalue
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.endvalue
        )} ]`;
        if (this.state.testIDType != "import") test.names = null;
      }
    } else {
      if (this.state.testIDType != "import") test.names = null;
    }
    this.setState({ test, errors, cablemodels, isNonGenericCableBrand });
  };

  onToggleChange = (e, checked) => {
    let test = { ...this.state.test };
    test[e.target.name] = checked;
    this.setState({ test: test });
  };

  onCustomCheckChange = e => {
    let test = { ...this.state.test };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let enabled = !metadataOption.enabled;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      enabled: enabled,
      field: document.querySelector(`select[name="${e.target.name}"]`).value,
      value: ""
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onCustomChange = e => {
    let test = { ...this.state.test };

    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let field = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      field
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onChangeMetadataField = e => {
    let { test, errors } = { ...this.state };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let value = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      value
    };
    errors[e.target.name] = false;
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test, errors });
  };

  validate = currentTab => {
    const { test, tabPosition, testIDType } = this.state;
    const { job, translate } = this.props;
    let validationData = {};
    let errors = {};
    switch (currentTab || currentTab === 0 ? currentTab : tabPosition) {
      case 0:
        if (testIDType == "sequential") {
          if (
            job.metadatalookupid !== null &&
            job.metadatalookupid !== CUSTOM_METADATA_STANDARD
          ) {
            validationData = {
              floor: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 3,
                  message: translate("formfield_error_general_length", {
                    value: 3
                  })
                },
                type: {
                  value: "alphanumeric",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              telecommunicationspace: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 1,
                  message: translate("formfield_error_general_length", {
                    value: 1
                  })
                },
                type: {
                  value: "alphanumeric",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              panel: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 2,
                  message: translate("formfield_error_general_length", {
                    value: 2
                  })
                },
                type: {
                  value: "alphanumeric",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              startvalue: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 4,
                  message: translate("formfield_error_general_length", {
                    value: 4
                  })
                },
                type: {
                  value: "numeric",
                  message: translate("formfield_error_general_type_numeric")
                }
              },
              endvalue: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 4,
                  message: translate("formfield_error_general_length", {
                    value: 4
                  })
                },
                type: {
                  value: "numeric",
                  message: translate("formfield_error_general_type_numeric")
                }
              }
            };
          } else {
            validationData = {
              prefix: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "alphanumericspecial",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              startvalue: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "alphanumericspecial",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              endvalue: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "alphanumericspecial",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              }
            };
          }
        }
        break;
      case 1:
        validationData = {
          cablestandard: {
            required: translate("formfield_error_general_required")
          },
          linkmodel: {
            required: translate("formfield_error_general_required")
          },
          cabletype: {
            required: translate("formfield_error_general_required")
          },
          cablebrand: {
            required: translate("formfield_error_general_required")
          },
          cablemodelid: {
            required: translate("formfield_error_general_required")
          },
          cableshielding: {
            required: translate("formfield_error_general_required")
          },
          nvp: {
            required: translate("formfield_error_general_required"),
            range: {
              minValue: 50,
              maxValue: 99,
              message: translate("test_nvp_out_of_range_desc", { min: 50, max: 99 })
            }
          }
        };
        break;
      case 2:
        test.metadata.map(x => {
          if (x.enabled && x.value.trim() === "") {
            errors[x.level] = true;
          } else if (x.enabled && x.value.length > 12) {
            errors[x.level] = true;
          }
        });
        break;
      default:
        return true;
    }

    if (
      tabPosition === 2 &&
      currentTab === tabPosition &&
      job.metadatalookupid === CUSTOM_METADATA_STANDARD
    ) {
    } else {
      errors = validateFormData(test, validationData);
    }

    if (testIDType == "sequential" && tabPosition === 0) {
      errors = validateFormData(test, validationData);
      if (!this.state.test.names && !Object.keys(errors)[0]) {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          "test_maximum_allowed_range"
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          "test_maximum_allowed_range"
        )} ]`;
      }
    }

    if (testIDType == "sequential" && tabPosition === 0) {
      errors = validateFormData(test, validationData);
      if (!this.state.test.names && !Object.keys(errors)[0]) {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          "test_maximum_allowed_range"
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          "test_maximum_allowed_range"
        )} ]`;
      }
    }

    if (testIDType == "import" && tabPosition === 0) {
      delete errors.startvalue;
      delete errors.endvalue;
      delete errors.prefix;
      if (this.state.lantekfiles == null || this.state.test.names == null || this.state.test.names.length === 0) {
        errors.importFile = "Required";
      }
      else if (this.state.test.names.length > 2000) {
        errors.importFile = "LimitExceeded";
      }
      // validationData = {
      //   lantekfiles: {
      //     required: translate("formfield_error_general_required")
      //   }
      // };
    }

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();

      if (Number.isInteger(parseInt(missingFieldName))) {
        toast.error(
          ` ${this.props.translate("test_create_invalid_identifier")}`,
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true
          }
        );
      }
    }

    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({ errors, tabPosition: currentTab });
      }
      return false;
    } else {
      this.setState({ errors });
      return true;
    }
  };

  createTests() {
    let isValidated = false;
    const { tabPosition } = this.state;
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab);
      if (!isValidated) {
        return;
      }
    }
    if (isValidated) {
      let { test, testIDType } = this.state;
      const { job, pager, userPreference } = this.props;

      if (!test.nvp) {
        test = { ...test, nvp: 0 };
      }

      if (
        job.metadatalookupid !== null &&
        job.metadatalookupid !== CUSTOM_METADATA_STANDARD
      ) {
        test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
      }

      //Remove Disabled Metadata
      if (job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) {
        let metadata = [...test.metadata];
        metadata.map(e => {
          if (!e.enabled) {
            e.field = "";
            e.value = "";
            return e;
          }
        });
        test.metadata = metadata;
      }
      if (job.metadatalookupid != CUSTOM_METADATA_STANDARD && (userPreference && !userPreference.FromTreeview)) {
        var tempMetadata = test.metadata.map(i => {
          return { ...i, ...{ value: null } };
        });
        test = { ...test, metadata: tempMetadata };
      }
      if (!this.props.isCopperTest) {
        test = {
          ...test,
          cableshielding: "S/STP",
          testtype: "CoaxialCable"
        };
      } else {
        test = {
          ...test,
          testtype: "TwistedPairCable"
        };
      }
      if (testIDType === "import") {
        test.names = test.names.filter(
          (value, index) => test.names.indexOf(value) === index
        );
      }
      this.props.saveNewTests(test, pager);
    }
  }

  onTestPrefixTypeChange(e) {
    let test = { ...this.state.test };
    let testPrefixType = e.target.value;

    let errors = { ...this.state.errors };

    const { translate } = this.props;

    if (e.target.value !== "custom") {
      test.prefix =
        this.props.custom
          .find(cust => cust.level === 1)
          .values.find(obj => {
            return obj.id === e.target.value;
          }).name || "";
    } else {
      test.prefix = "";
    }
    if (test.startvalue && test.endvalue && test.prefix) {
      let names = generateNames(
        test.prefix,
        test.startvalue,
        test.endvalue,
        10000,
        errors
      );
      if (names) {
        test.names = names;
        delete errors.startvalue;
        delete errors.endvalue;
      } else {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.startvalue
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.endvalue
        )} ]`;
        test.names = null;
      }
    } else {
      test.names = null;
    }
    this.setState({
      test,
      testPrefixType
    });
  }

  onTestIDTypeChange = e => {
    let { errors } = { ...this.state };
    let test = { ...this.state.test };
    //this.setState({ testIDType: e.target.value });
    this.props.clearImportDuplicateError();
    if (e.target.value == "import") {
      errors.startvalue = false;
      errors.endvalue = false;
      errors.prefix = false;
    }
    errors.importFile = false;
    test.names = null;
    test.prefix = "";
    test.startvalue = "01";
    test.endvalue = "24";
    this.setState({
      testIDType: e.target.value,
      errors,
      test,
      testPrefixType: "custom",
      lantekfiles: null
    });
  };

  handleUpload() {
    let fd = new FormData();
    let lantekfiles = { ...this.state.lantekfiles };
    let { errors } = { ...this.state };
    Object.keys(lantekfiles).forEach(key => {
      fd.append("file", lantekfiles[key]);
    });
    errors.importFile = false;
    //alert("test");
    this.props.clearDuplicateError();
    this.props.uploadTestIDFile(fd);
    this.setState({
      errors
    });
    // this.props
    //   .uploadTestIDFile(fd)
    //   .then(resp => {
    //     // self.closeUploadLantekModal();
    //     // self.closeImportTestModal();
    //   })
    //   .catch(errors => {
    //     console.log("ERRRRRRR" + errors);
    //   });
  }

  handleImport(e) {
    let { errors } = { ...this.state };
    errors.importFile = false;
    this.setState({
      errors
    });
    if (e.target.type == "file" && e.target.files.length) {
      // const totalBytes = Object.keys(e.target.files).reduce(
      //   (total, file) => total + e.target.files[file].size,
      //   0
      // );
      // 1 MB = 1048576 bytes
      // if (Math.round(totalBytes / 1048576) >= APP_CONFIG.maxFileUploadSize) {
      //   toast.error(
      //     ` ${this.props.translate(
      //       "jobs_upload_lantek_files_large_filesize_unsuccessfull_toast"
      //     )}`,
      //     {
      //       position: toast.POSITION.TOP_CENTER,
      //       hideProgressBar: true
      //     }
      //   );
      //   document.getElementById("lantekfiles").value = "";
      //   this.setState({
      //     lantekfiles: null,
      //     testFileArray: null,
      //     jobFileArray: null
      //   });
      //   return;
      // }
      this.setState({
        [e.target.name]: e.target.files
        // testFileArray: Array.from(e.target.files).filter(
        //   file =>
        //     file.name
        //       .split(".")
        //       .pop()
        //       .toLowerCase() !== "job"
        // ),
        // jobFileArray: Array.from(e.target.files).filter(
        //   file =>
        //     file.name
        //       .split(".")
        //       .pop()
        //       .toLowerCase() === "job"
        // )
      });
    }
  }

  render() {
    const { classes, translate, job, isCopperTest, userPreference } = this.props;

    let { custom, standards, error, IDerrors } = this.props;
    let metadataOption;
    const {
      test,
      errors,
      tabs,
      testPrefixType,
      tabPosition,
      disabledToogleIdentifier,
      cablemodels,
      linkmodels,
      cabletypes,
      isNonGenericCableBrand,
      testIDType,
      lantekfiles,
      modalRef
    } = this.state;
    
    let cablestandards, cablebrands, connectorbrands, cablemodeltypes;

    if (standards) {
      cablestandards = isCopperTest
        ? standards.cablestandards.filter(n => n.coax == false)
        : standards.cablestandards.filter(n => n.coax == true);
      //CHANGE
      cablebrands = isCopperTest
        ? standards.cablebrands.filter(
            x => x.cablemodels.filter(x => x.coax == false).length >= 1
          )
        : standards.cablebrands.filter(
            x => x.cablemodels.filter(x => x.coax == true).length >= 1
          );

      if (!isNonGenericCableBrand) {
        cablemodeltypes = isCopperTest
        ? cablemodels.filter(x => x.coax === false)
        : cablemodels.filter(x => x.coax === true);
      } 

      connectorbrands = isCopperTest
        ? standards.connectorbrands.filter(
            x => x.connectormodels.filter(x => x.coax == false).length >= 1
          )
        : standards.connectorbrands.filter(
            x => x.connectormodels.filter(x => x.coax == true).length >= 1
          );
      if (!isCopperTest) {
        cablebrands = cablebrands.sort(function(a, b) {
          return a.order < b.order ? 1 : b.order < a.order ? -1 : 0;
        });
        connectorbrands = connectorbrands.sort(function(a, b) {
          return a.order < b.order ? 1 : b.order < a.order ? -1 : 0;
        });
      }
    }

    if (!custom) return null;

    custom = custom.sort((a, b) => b.level > a.level);
    let showAllMetadataSwitch =
      this.state.test.metadata.filter(n => n.field).length !== 6;
    return (
      <Modal open={this.state.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_add")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              {error && error === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_duplicate_error")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              {error && error === "error_testnamesize_exceeds_80chars" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}
              {error && error === "nvp_out_of_range" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_nvp_out_of_range")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_nvp_out_of_range_desc", { min: 50, max: 99 })}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "invalid_character" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_char")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "maximum_length_exceed" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "too_many_test_to_import" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_numbers")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "error_wrongfiletype" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_type")}
                  </Typography>
                </Paper>
              )}

              {IDerrors && IDerrors === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={tab} />;
                  })}
                </Tabs>

                {tabPosition === 0 && (
                  <div className={classes.summary}>
                    {(job.metadatalookupid === null ||
                      job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) && (
                      <div>
                        {/* {testPrefixType === "custom" && ( */}
                        <FormControl>
                          <RadioGroup
                            aria-label="chartLine"
                            name="chartLine"
                            className={classes.group}
                            value={testIDType}
                            onChange={this.onTestIDTypeChange}
                            row={true}
                          >
                            <FormControlLabel
                              value="sequential"
                              control={<Radio />}
                              label={translate("sequential_test_ids")}
                            />
                            <FormControlLabel
                              value="import"
                              control={<Radio />}
                              label={translate("import_test_ids")}
                            />
                          </RadioGroup>
                        </FormControl>
                        {testIDType === "import" && (
                          <div>
                            {/* <form
                              noValidate
                              autoComplete="off"
                              className={classes.form_inner}
                            > */}
                            <div className={classes.uploadlabel}>
                              <InputLabel
                                htmlFor="testPrefixType"
                                className={classes.fileUpload}
                              >
                                {translate("select_spreadsheet_to_import")}
                              </InputLabel>
                            </div>
                            <FormControl
                              fullWidth
                              error={errors.lantekfiles ? true : false}
                            >
                              <Input
                                className={classes.upload}
                                id="lantekfiles"
                                type="file"
                                name="lantekfiles"
                                onChange={this.handleImport}
                                //value={lantekfiles}
                                inputProps={{
                                  name: "lantekfiles", 
                                  multiple: false,
                                  accept: ".xlsx,.csv"
                                }}
                                error={errors.lantekfiles ? true : false}
                                helperText={
                                  errors.lantekfiles
                                    ? errors.lantekfiles
                                    : 'translate("test_custom_prefix_help")'
                                }
                              />
                              {/* <FormHelperText id="lantekfiles-helper-text">
                              {"Please Select a single file."}
                            </FormHelperText> */}
                            </FormControl>
                            {/* </form> */}
                            <Button
                              className={classes.import}
                              error={errors.importFile ? true : false}
                              raised
                              color="primary"
                              onClick={this.handleUpload}
                              disabled={lantekfiles == null}
                              helperText={
                                errors.importFile
                                  ? errors.importFile
                                  : 'translate("test_custom_prefix_help")'
                              }
                            >
                              {translate("general_import").toUpperCase()}
                            </Button>
                            {/* {$fileLists}
                          {$jobFile} */}
                            <HtmlTooltip
                              title={
                                <React.Fragment>
                                  <ul>
                                    <li>{translate("test_ids_tooltip_1")}</li>
                                    <li>{translate("test_ids_tooltip_2")}</li>
                                    <li>{translate("test_ids_tooltip_3")}</li>
                                    <li>{translate("test_ids_tooltip_4")}</li>
                                  </ul>
                                </React.Fragment>
                              }
                            >
                              <div className={classes.tooltip}>[?]</div>
                            </HtmlTooltip>
                            {(errors.importFile === "Required") && (
                              <Typography className={classes.uploadValidation}>
                                {translate("import_test_ids_required")}
                              </Typography>
                            )}
                            {(errors.importFile === "LimitExceeded") && (
                              <Typography className={classes.uploadValidation}>
                                {translate("import_test_ids_limit_exceeded")}
                              </Typography>
                            )}
                          </div>
                        )}
                        {testIDType === "sequential" && (
                          <FormControl
                            className={classes.textField}
                            margin="normal"
                          >
                            <InputLabel htmlFor="testPrefixType">
                              {translate("test_prefix")}
                            </InputLabel>
                            <Select
                              value={testPrefixType}
                              onChange={this.onTestPrefixTypeChange.bind(this)}
                              input={
                                <Input
                                  name="testPrefixType"
                                  id="testPrefixType"
                                  value={testPrefixType}
                                />
                              }
                              fullWidth
                            >
                              {custom
                                ? custom
                                    .find(c => c.level === 1)
                                    .values.map((c, index) => {
                                      return (
                                        <MenuItem
                                          key={`testPrefixType-${index}`}
                                          value={c.id}
                                        >
                                          {c.name}
                                        </MenuItem>
                                      );
                                    })
                                : null}
                              <MenuItem
                                key="testPrefixTypeCustom"
                                value="custom"
                              >
                                {translate("test_custom")}
                              </MenuItem>
                            </Select>
                            <FormHelperText>
                              {errors.cablestandard
                                ? errors.cablestandard
                                : translate("test_prefix_help")}
                            </FormHelperText>
                          </FormControl>
                        )}
                        {testIDType === "sequential" &&
                          testPrefixType === "custom" && (
                            <TextField
                              error={errors.prefix ? true : false}
                              required
                              name="prefix"
                              label={translate("test_custom_prefix")}
                              margin="normal"
                              fullWidth
                              value={test.prefix}
                              onChange={this.onChange}
                              inputProps={{
                                maxlength: 76
                              }}
                              helperText={
                                errors.prefix
                                  ? errors.prefix
                                  : translate("test_custom_prefix_help")
                              }
                            />
                          )}
                        {testIDType === "sequential" && (
                          <TextField
                            error={errors.startvalue ? true : false}
                            required
                            name="startvalue"
                            label={translate("test_startvalue")}
                            margin="normal"
                            fullWidth
                            value={test.startvalue}
                            onChange={this.onChange}
                            helperText={
                              errors.startvalue
                                ? errors.startvalue
                                : translate("test_startvalue_help")
                            }
                          />
                        )}
                        {testIDType === "sequential" && (
                          <TextField
                            error={errors.endvalue}
                            required
                            name="endvalue"
                            label={translate("test_endvalue")}
                            margin="normal"
                            fullWidth
                            value={test.endvalue}
                            onChange={this.onChange}
                            helperText={
                              errors.endvalue
                                ? errors.endvalue
                                : translate("test_endvalue_help")
                            }
                          />
                        )}
                        {/* <TextField
                          error={errors.startvalue ? true : false}
                          required
                          name="startvalue"
                          label={translate("test_startvalue")}
                          margin="normal"
                          fullWidth
                          value={test.startvalue}
                          onChange={this.onChange}
                          helperText={
                            errors.startvalue
                              ? errors.startvalue
                              : translate("test_startvalue_help")
                          }
                        />
                        <TextField
                          error={errors.endvalue}
                          required
                          name="endvalue"
                          label={translate("test_endvalue")}
                          margin="normal"
                          fullWidth
                          value={test.endvalue}
                          onChange={this.onChange}
                          helperText={
                            errors.endvalue
                              ? errors.endvalue
                              : translate("test_endvalue_help")
                          }
                        /> */}
                        {test.names && (
                          <React.Fragment>
                            <Grid container className={classes.testRange}>
                              <Grid item xs={12} sm={6}>
                                <Typography type="caption">
                                  {translate("test_ranges")}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography type="caption" align="right">
                                  {translate("test_ranges_total")} -{" "}
                                  <strong
                                    style={{ color: "rgba(0, 0, 0, 0.87)" }}
                                  >
                                    {test.names.length}
                                  </strong>
                                </Typography>
                              </Grid>
                            </Grid>
                            <List
                              disablePadding={true}
                              className={classes.scrollableList}
                            >
                              {test.names.map((val, i) => {
                                return (
                                  <ListItem key={`testnames-${i}`}>
                                    <ListItemText primary={val} />
                                  </ListItem>
                                );
                              })}
                            </List>
                          </React.Fragment>
                        )}
                      </div>
                    )}
                    {job.metadatalookupid &&
                      job.metadatalookupid !== CUSTOM_METADATA_STANDARD && (
                        <div>
                          <div className={classes.summary}>
                            <TextField
                              error={errors.floor ? true : false}
                              required
                              name="floor"
                              label={translate("test_floor")}
                              margin="normal"
                              fullWidth
                              value={test.floor}
                              onChange={this.onChange}
                              helperText={
                                errors.floor
                                  ? errors.floor
                                  : translate("test_floor_help")
                              }
                            />

                            <TextField
                              error={
                                errors.telecommunicationspace ? true : false
                              }
                              required
                              name="telecommunicationspace"
                              label={translate("test_telecommunicationspace")}
                              margin="normal"
                              fullWidth
                              value={test.telecommunicationspace}
                              onChange={this.onChange}
                              helperText={
                                errors.telecommunicationspace
                                  ? errors.telecommunicationspace
                                  : translate(
                                      "test_telecommunicationspace_help"
                                    )
                              }
                            />
                            <TextField
                              error={errors.panel ? true : false}
                              required
                              name="panel"
                              label={translate("test_panel")}
                              margin="normal"
                              fullWidth
                              value={test.panel}
                              onChange={this.onChange}
                              helperText={
                                errors.panel
                                  ? errors.panel
                                  : translate("test_panel_help")
                              }
                            />

                            <TextField
                              error={errors.startvalue ? true : false}
                              required
                              name="startvalue"
                              label={translate("test_portstartvalue")}
                              margin="normal"
                              fullWidth
                              value={test.startvalue}
                              onChange={this.onChange}
                              helperText={
                                errors.startvalue
                                  ? errors.startvalue
                                  : translate("test_portstartvalue_help")
                              }
                            />
                            <TextField
                              error={errors.endvalue ? true : false}
                              required
                              name="endvalue"
                              label={translate("test_portendvalue")}
                              margin="normal"
                              fullWidth
                              value={test.endvalue}
                              onChange={this.onChange}
                              helperText={
                                errors.endvalue
                                  ? errors.endvalue
                                  : translate("test_portendvalue_help")
                              }
                            />
                          </div>
                          {test.names && (
                            <React.Fragment>
                              <Grid container>
                                <Grid item xs={12} sm={6}>
                                  <Typography type="caption">
                                    {translate("test_ranges")}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <Typography type="caption" align="right">
                                    {translate("test_ranges_total")} -{" "}
                                    {test.names.length}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <List
                                disablePadding={true}
                                className={classes.scrollableList}
                              >
                                {test.names.map((val, i) => {
                                  return (
                                    <ListItem key={`testnames-${i}`}>
                                      <ListItemText primary={val} />
                                    </ListItem>
                                  );
                                })}
                              </List>
                            </React.Fragment>
                          )}
                        </div>
                      )}
                  </div>
                )}

                {tabPosition === 1 && (
                  <div className={classes.summary}>
                    {/* TEST STANDARD */}
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.cablestandard ? true : false}
                    >
                      <InputLabel htmlFor="cablestandard">
                        {translate("test_cable_standard")}
                      </InputLabel>
                      <Select
                        value={test.cablestandard}
                        onChange={this.onChange}
                        input={
                          <Input
                            name="cablestandard"
                            id="cablestandard"
                            value={test.cablestandard}
                          />
                        }
                        fullWidth
                      >
                        {cablestandards
                          ? cablestandards.map((standard, index) => {
                              return (
                                <MenuItem key={index} value={standard.id}>
                                  {standard.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.cablestandard
                          ? errors.cablestandard
                          : translate("test_cable_standard_help")}
                      </FormHelperText>
                    </FormControl>

                    {/* LINK MODEL */}
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.linkmodel ? true : false}
                    >
                      <InputLabel htmlFor="linkmodel">
                        {translate("test_link_model")}
                      </InputLabel>
                      <Select
                        value={test.linkmodel}
                        onChange={this.onChange}
                        input={
                          <Input
                            name="linkmodel"
                            id="linkmodel"
                            value={test.linkmodel}
                          />
                        }
                        fullWidth
                      >
                        {linkmodels
                          ? linkmodels.map((linkmodel, index) => {
                              return (
                                <MenuItem key={index} value={linkmodel.id}>
                                  {linkmodel.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.linkmodel
                          ? errors.linkmodel
                          : translate("test_link_model_help")}
                      </FormHelperText>
                    </FormControl>

                    {/* TEST LIMIT */}
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.cabletype ? true : false}
                    >
                      <InputLabel htmlFor="cabletype">
                        {translate("test_cable_type")}
                      </InputLabel>
                      <Select
                        value={test.cabletype}
                        onChange={this.onChange}
                        input={
                          <Input
                            name="cabletype"
                            id="cabletype"
                            value={test.cabletype}
                          />
                        }
                        fullWidth
                      >
                        {cabletypes
                          ? cabletypes.map((cabletype, index) => {
                              return (
                                <MenuItem key={index} value={cabletype.id}>
                                  {cabletype.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.cabletype
                          ? errors.cabletype
                          : translate("test_cable_type_help")}
                      </FormHelperText>
                    </FormControl>

                    {/* CABLE MANUFACTURER */}
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.cablebrand ? true : false}
                    >
                      <InputLabel htmlFor="cablestandard">
                        {translate("test_cable_brand")}
                      </InputLabel>
                      <Select
                        value={test.cablebrand}
                        onChange={this.onChange}
                        input={
                          <Input
                            name="cablebrand"
                            id="cablebrand"
                            value={test.cablebrand}
                            fullWidth
                          />
                        }
                      >
                        {cablebrands
                          ? cablebrands.map((cablebrand, index) => {
                              return (
                                <MenuItem key={index} value={cablebrand.id}>
                                  {cablebrand.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.cablebrand
                          ? errors.cablebrand
                          : translate("test_cable_brand_help")}
                      </FormHelperText>
                    </FormControl>

                    {/* CABLE TYPE   */}
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.cablemodelid ? true : false}
                    >
                      <InputLabel htmlFor="cablemodelid">
                        {translate("test_cable_model")}
                      </InputLabel>
                      <Select
                        value={test.cablemodelid}
                        onChange={this.onChange}
                        input={
                          <Input
                            name="cablemodelid"
                            id="cablemodelid"
                            value={test.cablemodelid}
                            fullWidth
                          />
                        }
                      >
                        {cablemodeltypes ? 
                          cablemodeltypes.map((cablemodel, index) => {
                            return (
                              <MenuItem key={index} value={cablemodel.id}>
                                {cablemodel.name}
                              </MenuItem>
                            );
                          }) :
                        cablemodels
                          ? cablemodels.map((cablemodel, index) => {
                              return (
                                <MenuItem key={index} value={cablemodel.id}>
                                  {cablemodel.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.cablemodelid
                          ? errors.cablemodelid
                          : translate("test_cable_model_help")}
                      </FormHelperText>
                    </FormControl>

                    <Grid container>
                      <Grid item xs={12} sm={6}>
                        {/* NEAR_END CONNECTOR MANUFACTURER */}
                        <FormControl
                          fullWidth
                          margin="normal"
                          error={errors.connectorbrandnear ? true : false}
                        >
                          <InputLabel htmlFor="connectorbrandnear">
                            {translate("test_connector_brand_near")}
                          </InputLabel>
                          <Select
                            value={test.connectorbrandnear}
                            onChange={this.onChange}
                            input={
                              <Input
                                name="connectorbrandnear"
                                id="connectorbrandnear"
                                value={test.connectorbrandnear}
                                fullWidth
                              />
                            }
                          >
                            {connectorbrands
                              ? connectorbrands.map((connectorbrand, index) => {
                                  return (
                                    <MenuItem
                                      key={index}
                                      value={connectorbrand.id}
                                    >
                                      {connectorbrand.name}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </Select>
                          <FormHelperText>
                            {errors.connectorbrandnear
                              ? errors.connectorbrandnear
                              : translate("test_connector_brand_near_help")}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        {/* FAR_END CONNECTOR MANUFACTURER */}
                        <FormControl
                          margin="normal"
                          fullWidth
                          error={errors.connectorbrandfar ? true : false}
                        >
                          <InputLabel htmlFor="connectorbrandfar">
                            {translate("test_connector_brand_far")}
                          </InputLabel>
                          <Select
                            value={test.connectorbrandfar}
                            onChange={this.onChange}
                            input={
                              <Input
                                name="connectorbrandfar"
                                id="connectorbrandfar"
                                value={test.connectorbrandfar}
                                fullWidth
                              />
                            }
                          >
                            {connectorbrands
                              ? connectorbrands.map((connectorbrand, index) => {
                                  return (
                                    <MenuItem
                                      key={index}
                                      value={connectorbrand.id}
                                    >
                                      {connectorbrand.name}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </Select>
                          <FormHelperText>
                            {errors.connectorbrandfar
                              ? errors.connectorbrandfar
                              : translate("test_connector_brand_far_help")}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid container>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          error={errors.nvp ? true : false}
                          name="nvp"
                          label={translate("test_nvp")}
                          margin="normal"
                          fullWidth
                          value={test.nvp}
                          onChange={this.onChange}
                          disabled={isNonGenericCableBrand}
                          helperText={
                            errors.nvp ? errors.nvp : translate("test_nvp_help")
                          }
                        />
                      </Grid>
                      {isCopperTest && (
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            component="fieldset"
                            required
                            className={classes.formControl}
                            error={errors.cableshielding ? true : false}
                          >
                            <FormLabel component="legend">
                              {translate("test_cable_shielding")}
                            </FormLabel>
                            <RadioGroup
                              aria-label="gender"
                              name="cableshielding"
                              className={classes.group}
                              value={test.cableshielding}
                              onChange={this.onChange}
                            >
                              <FormControlLabel
                                disabled={true}
                                value="U/UTP"
                                control={<Radio />}
                                label={translate("test_cable_shielding_uutp")}
                              />
                              <FormControlLabel
                                disabled={true}
                                value="S/STP"
                                control={<Radio />}
                                label={translate("test_cable_shielding_sftp")}
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      )}
                    </Grid>
                  </div>
                )}

                {tabPosition === 2 && (
                  <div className={classes.summary}>
                    {showAllMetadataSwitch && (
                      <Typography type="subheading">
                        <FormControlLabel
                          control={
                            <Switch
                              name="allmetadataoptions"
                              checked={test.allmetadataoptions}
                              onChange={(e, checked) =>
                                this.onToggleChange(e, checked)
                              }
                              disabled={disabledToogleIdentifier}
                            />
                          }
                          label={translate("test_add_metadata_item")}
                        />
                      </Typography>
                    )}

                    {custom &&
                      custom
                        .sort((a, b) => {
                          return a.level > b.level
                            ? -1
                            : a.level < b.level
                            ? 1
                            : 0;
                        })
                        .map((c, index) => {
                          metadataOption = test.metadata.find(
                            x => parseInt(x.level, 10) === parseInt(c.level, 10)
                          );
                          return (test.allmetadataoptions ||
                            metadataOption.default ||
                            metadataOption.enabled) &&
                            c.level !== 1 ? (
                            <div key={index}>
                              <Checkbox
                                name={c.level}
                                checked={metadataOption.enabled}
                                onChange={this.onCustomCheckChange}
                              />
                              <select
                                name={c.level}
                                value={metadataOption.field}
                                onChange={this.onCustomChange}
                                disabled={!metadataOption.enabled}
                              >
                                {c.values.map((o, index) => {
                                  return (
                                    <option key={index} value={o.id}>
                                      {o.name}
                                    </option>
                                  );
                                })}
                              </select>
                              <TextField
                                error={errors[c.level] ? true : false}
                                required
                                name={c.level}
                                margin="normal"
                                value={metadataOption.value}
                                onChange={this.onChangeMetadataField}
                                disabled={!metadataOption.enabled}
                              />
                            </div>
                          ) : null;
                        })}
                  </div>
                )}
              </form>
            </ModalContents>

            <ModalFooter>
              <Button
                raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={!this.canTabBack().can ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button
                raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={!this.canTabNext().can ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {this.tabsComplete() ? (
                <Button
                  raised
                  color="accent"
                  className={classes.submit}
                  onClick={() => this.createTests()}
                  type="submit"
                  disabled={
                    testIDType == "import" && Object.keys(IDerrors).length != 0
                  }
                >
                  {translate("test_create")}
                </Button>
              ) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { testNameList, IDerrors } = nextProps;
    let test = { ...this.state.test };
    if (this.props.testNameList !== testNameList) {
      test.names = testNameList;
      this.setState({
        test
      });
    }
    // if (this.props.IDerrors !== IDerrors) {
    //   var tempIDErrors = IDerrors == null ? {} : IDerrors;
    //   this.setState({
    //     IDerrors: tempIDErrors
    //   });
    // }
  }

  componentDidMount() {
    const { test } = this.state;
    const { isCopperTest, userPreference } = this.props;
    const disabledToogleIdentifier = test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
    var isUserPreferenceSaved = false;
    userPreference &&
      userPreference.metadata.map(x => {
        if (x.value != null) isUserPreferenceSaved = true;
      });
    if (isUserPreferenceSaved == true) {
      this.checkForAlreadySelectedSubtests(
        this.state.test,
        this.props.type == "copper" ? "true" : "false"
      );
    }

    if (!this.props.modalState) {
      const { standards } = this.props;
      let cablebrand = "";
      let cablemodelid = "";
      let nvp = 68;
      let cableshielding = isCopperTest ? "U/UTP" : "S/STP";
      let cablemodels = [];
      let linkmodels = [];
      let cabletypes = [];
      let cStandard2 = [];
      if (isCopperTest) {
        const brand =
          standards && standards.cablebrands
            ? standards.cablebrands.find(x => x.name.toLowerCase() == "generic")
            : null;
        if (brand) {
          cablebrand = brand.id;
          if (brand.cablemodels) {
            cablemodels = brand.cablemodels;
            let cablemodel = cablemodels.find(
              x => x.name.toLowerCase() == "cat6a"
            );
            if (cablemodel) {
              cablemodelid = cablemodel.id;
              if (
                cablemodel.nvp &&
                (cablemodel.nvp >= 50 && cablemodel.nvp <= 100)
              ) {
                nvp = cablemodel.nvp;
              } else {
                nvp = 68;
              }

              if (cablemodel.screen) {
                cableshielding = "S/STP";
              } else {
                cableshielding = "U/UTP";
              }
            }
          }
        } else {
          nvp = 68;
          cableshielding = "U/UTP";
        }

        if (standards && standards.cablestandards) {
          const cStandard = standards.cablestandards.find(
            o => o.name.toUpperCase() === "ISO/IEC 11801-1:2017 A1/2"
          );
          if (cStandard) {
            linkmodels = cStandard.linkmodels;
            test.cablestandardname = cStandard.name;
            test.cablestandard = cStandard.id;
            const lModel = cStandard.linkmodels.find(
              o => o.name.toUpperCase() === "PERMANENT LINK"
            );
            if (lModel) {
              cabletypes = lModel.cabletypes;
              test.linkmodelname = lModel.name;
              test.linkmodel = lModel.id;
              const cType = lModel.cabletypes.find(
                o => o.name.toUpperCase() === "CLASS EA PL1 PL2 CP1"
              );
              if (cType) {
                test.cabletypename = cType.name;
                test.cabletype = cType.id;
              }
            }
          }
        }
      } else {
        let cablebrandssorted = standards.cablebrands.sort(function(a, b) {
          return a.order < b.order ? 1 : b.order < a.order ? -1 : 0;
        });
        const brand = cablebrandssorted
          ? cablebrandssorted.filter(
              x => x.cablemodels.filter(x => x.coax == true).length >= 1
            )[0]
          : null;
        if (brand) {
          cablebrand = brand.id;
          if (brand.cablemodels) {
            cablemodels = brand.cablemodels.filter(n => n.coax == true);
            let cablemodel = cablemodels ? cablemodels[0] : [];
            if (cablemodel) {
              //cablemodelid = cablemodel.id;
              if (
                cablemodel.nvp &&
                (cablemodel.nvp >= 50 && cablemodel.nvp <= 100)
              ) {
                nvp = cablemodel.nvp;
              } else {
                nvp = 68;
              }
            }
          }

          if (standards && standards.cablestandards) {
            cStandard2 = standards.cablestandards.filter(
              n => n.coax == true
            )[0];

            if (cStandard2) {
              linkmodels = cStandard2.linkmodels;
              test.cablestandardname = cStandard2.name;
              test.cablestandard = cStandard2.id;
              const lModel = cStandard2.linkmodels[0];
              if (lModel) {
                cabletypes = lModel.cabletypes;
                test.linkmodelname = lModel.name;
                test.linkmodel = lModel.id;
                const cType = lModel.cabletypes[0];
                if (cType) {
                  test.cabletypename = cType.name;
                  test.cabletype = cType.id;
                }
              }
            }
          }
        }
      }

      this.setState({
        test: {
          ...test,
          cablebrand,
          cablemodelid,
          nvp,
          cableshielding
        },
        cablemodels,
        linkmodels,
        cabletypes
      });
    }
  }

  componentWillMount() {
    const { isCopperTest, standards } = this.props;
    const test = this.props.modalState;
    if (this.props.modalState) {
      if (test.testtype == "TwistedPairCable" && this.props.isCopperTest) {
        //const standards = this.props.standards;
        let cablemodels = [];
        let linkmodels = [];
        let cabletypes = [];
        let isNonGenericCableBrand = false;
        if (test.cablebrand) {
          const brand = standards
            ? standards.cablebrands.find(x => x.id == test.cablebrand)
            : null;
          if (brand) {
            if (brand.name.toLowerCase() == "generic") {
              isNonGenericCableBrand = false;
            } else {
              isNonGenericCableBrand = true;
            }
            cablemodels = brand.cablemodels;
          }
        }
        if (test.cablestandard) {
          const standard =
            standards && standards.cablestandards
              ? standards.cablestandards.find(x => x.id == test.cablestandard)
              : null;
          linkmodels =
            standard && standard.linkmodels ? standard.linkmodels : null;
        }
        if (test.linkmodel) {
          const linkmodel = linkmodels
            ? linkmodels.find(x => x.id == test.linkmodel)
            : null;
          cabletypes =
            linkmodel && linkmodel.cabletypes ? linkmodel.cabletypes : null;
        }
        this.setState({
          test,
          isNonGenericCableBrand,
          cablemodels,
          linkmodels,
          cabletypes
        });
      } else if (
        test.testtype == "TwistedPairCable" &&
        !this.props.isCopperTest
      ) {
        let cablebrand = "";
        let cablemodelid = "";
        let nvp = 68;
        let cableshielding = isCopperTest ? "U/UTP" : "S/STP";
        let cablemodels = [];
        let linkmodels = [];
        let cabletypes = [];
        let cStandard2 = [];
        let cablebrandssorted = standards.cablebrands.sort(function(a, b) {
          return a.order < b.order ? 1 : b.order < a.order ? -1 : 0;
        });
        const brand = cablebrandssorted
          ? cablebrandssorted.filter(
              x => x.cablemodels.filter(x => x.coax == true).length >= 1
            )[0]
          : null;
        if (brand) {
          cablebrand = brand.id;
          if (brand.cablemodels) {
            cablemodels = brand.cablemodels.filter(n => n.coax == true);
            let cablemodel = cablemodels ? cablemodels[0] : [];
            if (cablemodel) {
              cablemodelid = cablemodel.id;
              if (
                cablemodel.nvp &&
                (cablemodel.nvp >= 50 && cablemodel.nvp <= 100)
              ) {
                nvp = cablemodel.nvp;
              } else {
                nvp = 68;
              }
            }
          }

          if (standards && standards.cablestandards) {
            cStandard2 = standards.cablestandards.filter(
              n => n.coax == true
            )[0];

            if (cStandard2) {
              linkmodels = cStandard2.linkmodels;
              test.cablestandardname = cStandard2.name;
              test.cablestandard = cStandard2.id;
              const lModel = cStandard2.linkmodels[0];
              if (lModel) {
                cabletypes = lModel.cabletypes;
                test.linkmodelname = lModel.name;
                test.linkmodel = lModel.id;
                const cType = lModel.cabletypes[0];
                if (cType) {
                  test.cabletypename = cType.name;
                  test.cabletype = cType.id;
                }
              }
            }
          }
        }
        this.setState({
          test: {
            ...test,
            cablebrand,
            cablemodelid,
            nvp,
            cableshielding
          },
          cablemodels,
          linkmodels,
          cabletypes
        });
      } else if (test.testtype == "CoaxialCable" && this.props.isCopperTest) {
        let cablebrand = "";
        let cablemodelid = "";
        let nvp = 68;
        let cableshielding = isCopperTest ? "U/UTP" : "S/STP";
        let cablemodels = [];
        let linkmodels = [];
        let cabletypes = [];
        let cStandard2 = [];
        const brand =
          standards && standards.cablebrands
            ? standards.cablebrands.find(x => x.name.toLowerCase() == "generic")
            : null;
        if (brand) {
          cablebrand = brand.id;
          if (brand.cablemodels) {
            cablemodels = brand.cablemodels;
            let cablemodel = cablemodels.find(
              x => x.name.toLowerCase() == "cat6a"
            );
            if (cablemodel) {
              cablemodelid = cablemodel.id;
              if (
                cablemodel.nvp &&
                (cablemodel.nvp >= 50 && cablemodel.nvp <= 100)
              ) {
                nvp = cablemodel.nvp;
              } else {
                nvp = 68;
              }

              if (cablemodel.screen) {
                cableshielding = "S/STP";
              } else {
                cableshielding = "U/UTP";
              }
            }
          }
        } else {
          nvp = 68;
          cableshielding = "U/UTP";
        }

        if (standards && standards.cablestandards) {
          const cStandard = standards.cablestandards.find(
            o => o.name.toUpperCase() === "ISO/IEC 11801-1:2017 A1/2"
          );
          if (cStandard) {
            linkmodels = cStandard.linkmodels;
            test.cablestandardname = cStandard.name;
            test.cablestandard = cStandard.id;
            const lModel = cStandard.linkmodels.find(
              o => o.name.toUpperCase() === "PERMANENT LINK"
            );
            if (lModel) {
              cabletypes = lModel.cabletypes;
              test.linkmodelname = lModel.name;
              test.linkmodel = lModel.id;
              const cType = lModel.cabletypes.find(
                o => o.name.toUpperCase() === "CLASS EA PL1 PL2 CP1"
              );
              if (cType) {
                test.cabletypename = cType.name;
                test.cabletype = cType.id;
              }
            }
          }
        }
        this.setState({
          test: {
            ...test,
            cablebrand,
            cablemodelid,
            nvp,
            cableshielding
          },
          cablemodels,
          linkmodels,
          cabletypes
        });
        
      } else if (test.testtype == "CoaxialCable" && !this.props.isCopperTest) {
        //const standards = this.props.standards;
        let cablemodels = [];
        let linkmodels = [];
        let cabletypes = [];
        let isNonGenericCableBrand = false;
        if (test.cablebrand) {
          const brand = standards
            ? standards.cablebrands.find(x => x.id == test.cablebrand)
            : null;
          if (brand) {
            if (brand.name.toLowerCase() == "generic") {
              isNonGenericCableBrand = false;
            } else {
              isNonGenericCableBrand = true;
            }
            if (brand.cablemodels) {
              cablemodels = brand.cablemodels.filter(n => n.coax == true);
            }
          }
          // const brand =
          //   standards && standards.cablebrands
          //     ? standards.cablebrands.filter(
          //         x => x.cablemodels.filter(x => x.coax == true).length >= 1
          //       )[0]
          //     : null;
          //if (brand) {
          // if (brand.name.toLowerCase() == "generic") {
          //   isNonGenericCableBrand = false;
          // } else {
          //   isNonGenericCableBrand = true;
          // }
          // if (brand.cablemodels) {
          //   cablemodels = brand.cablemodels.filter(n => n.coax == true);
          // }
          //}
        }
        // if (test.cablestandard) {
        //   const standard =
        //     standards && standards.cablestandards
        //       ? standards.cablestandards.find(x => x.id == test.cablestandard)
        //       : null;
        //   linkmodels =
        //     standard && standard.linkmodels ? standard.linkmodels : null;
        // }
        // if (test.linkmodel) {
        //   const linkmodel = linkmodels
        //     ? linkmodels.find(x => x.id == test.linkmodel)
        //     : null;
        //   cabletypes =
        //     linkmodel && linkmodel.cabletypes ? linkmodel.cabletypes : null;
        // }
        if (test.cablestandard) {
          const standard =
            standards && standards.cablestandards
              ? standards.cablestandards.find(x => x.id == test.cablestandard)
              : null;
          linkmodels =
            standard && standard.linkmodels ? standard.linkmodels : null;
        }
        if (test.linkmodel) {
          const linkmodel = linkmodels
            ? linkmodels.find(x => x.id == test.linkmodel)
            : null;
          cabletypes =
            linkmodel && linkmodel.cabletypes ? linkmodel.cabletypes : null;
        }
        this.setState({
          test,
          isNonGenericCableBrand,
          cablemodels,
          linkmodels,
          cabletypes
        });
      }
    }
  }
}

export default withStyles(styles)(NewTests);



// WEBPACK FOOTER //
// ./src/components/job/new/index.js